export const iconFontAwesomeBuildingsSchoolCircleCheck = (
	<i className="fa-solid fa-school-circle-check"></i>
);
